<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input class="filter-item" v-model="listQuery.hotel_id" placeholder="龙腾酒店ID" style="width: 220px;" clearable size="small"/>
      <el-input class="filter-item" v-model="listQuery.room_type_name" placeholder="房间名称" style="width: 220px;" clearable
                size="small"/>
      <el-input class="filter-item" v-model="listQuery.rate_plan_name" placeholder="价格计划名称" style="width: 220px;" clearable
                size="small"/>
      <el-date-picker
          v-model="dateArr"
          type="datetimerange"
          :default-time="['00:00:00', '23:59:59']"
          align="right"
          value-format="yyyy-MM-dd HH:mm:ss"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          class="filter-item"
          style="display: inline-flex"
          size="small"
      ></el-date-picker>
      <el-button class="filter-item" type="primary" @click="handleFilter" size="small">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>
      <el-table-column label="ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.id }}
        </template>
      </el-table-column>

      <el-table-column label="龙腾酒店ID" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.hotel_id }}
        </template>
      </el-table-column>
      <el-table-column label="房间ID" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_id||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="房间名称" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.room_name||"-" }}
        </template>
      </el-table-column>

      <el-table-column label="价格计划ID" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.product_code||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="价格计划名称" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.rate_plan_name||"-" }}
        </template>
      </el-table-column>
<!--      <el-table-column label="预付早餐" min-width="120" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          {{ scope.row.advance_breakfast_count||"-" }}-->
<!--        </template>-->
<!--      </el-table-column>-->
<!--      <el-table-column label="预付其他费用" min-width="120" align="center">-->
<!--        <template slot-scope="scope">-->
<!--          {{ scope.row.advance_fee_rate||"-" }}-->
<!--        </template>-->
<!--      </el-table-column>-->
      <el-table-column label="营业日期" min-width="120" align="center">
        <template slot-scope="scope">
          {{scope.row.date||"-" }}
        </template>
      </el-table-column>

      <el-table-column label="价格" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.price||"-" }}
        </template>
      </el-table-column>
      <el-table-column label="可售房量" min-width="120" align="center">
        <template slot-scope="scope">
          {{ scope.row.count||"-" }}
        </template>
      </el-table-column>
      <el-table-column class-name="status-col" label="状态" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status == '026001'" type="success">开启</el-tag>
          <el-tag v-else-if="scope.row.status == '026002'" type="danger">开启</el-tag>
          <el-tag v-else type="warning">其他</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.created_at }}
        </template>
      </el-table-column>
      <el-table-column label="同步时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.sync_at }}
        </template>
      </el-table-column>
      <el-table-column label="同步时间" min-width="160" align="center">
        <template slot-scope="scope">
          {{ scope.row.sync_at }}
        </template>
      </el-table-column>
<!--      <el-table-column label="操作" width="250" align="center" fixed="right" class-name="small-padding fixed-width">-->
<!--        <template slot-scope="scope">-->
<!--          <el-button type="warning" size="mini" @click="handleSalesRoomType(scope.row)">售卖房型</el-button>-->
<!--        </template>-->
<!--      </el-table-column>-->
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[5,10,20,30,50]" :page-size="listQuery.limit" :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
  import request from "@/utils/request";
  import moment from "moment";

  export default {
    computed: {
      moment() {
        return moment
      }
    },
    watch: {
      dateArr(newVal) {
        if (newVal) {
          this.listQuery.start_at = newVal[0];
          this.listQuery.end_at = newVal[1];
        } else {
          this.listQuery.start_at = "";
          this.listQuery.end_at = "";
        }
      },
    },
    data() {
      return {
        list: null,
        total: null,
        listLoading: false,
        dateArr: null,
        listQuery: {
          page: 1,
          limit: 10,
          hotel_name: "",
          basic_room_type_name: "",
          with_total:true
        },
      };
    },
    created() {
      // this.getList();
    },
    methods: {
      getList() {
        if(!this.listQuery.hotel_id){
          this.$message({
            type: 'warning',
            message: '请输入龙腾酒店ID',
          })

          return
        }

        this.listLoading = true;
        request({
          url: "/api/backend/longTeng/hotel/hotelRoomStatusList",
          method: "get",
          params: this.listQuery,
        }).then(response => {
          this.list = response.data.items;
          this.total = response.data.total;
          this.listLoading = false;
        });
      },
      handleFilter() {
        this.listQuery.page = 1;
        this.getList();
      },
      handleSizeChange(val) {
        this.listQuery.limit = val;
        this.getList();
      },
      handleCurrentChange(val) {
        this.listQuery.page = val;
        this.getList();
      },
      // 售卖房型
      handleSalesRoomType(row) {
        this.$router.push(`/salesRoomTypeList?basic_room_type_id=${row.id}`);
      },
    }
  };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

</style>
